import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

import type { User } from '@coin-depo-types';
import { StorageService } from '@coin-depo-core/storage';
import { AuthService } from '@coin-depo/services';
import { UsersApiService } from '@coin-depo/http';

import type {
  ExtendedApiResponse,
  WaitListRequest,
  WaitListResponse
} from '@coin-depo-types';

@Injectable()
export class WaitListBannerService {

  constructor(
    private storage: StorageService,
    private auth: AuthService,
    private userApi: UsersApiService,
  ) {
  }

  get showDashboardBanner(): boolean {
    return this.storage.get('showDashboardBanner', true);
  }

  set showDashboardBanner(val: boolean) {
    this.storage.set('showDashboardBanner', val);
  }

  get waitListId(): number {
    return this.storage.get('waitListId');
  }

  set waitListId(val: number) {
    this.storage.set('waitListId', val);
  }

  waitListManage(create = false): Observable<ExtendedApiResponse<WaitListResponse & {email: string}> | string> {
    const client_token = this.auth.accessToken;
    const { username, email, id } = this.auth.userData

    if (client_token) {
      const data: WaitListRequest = {
        username: username || email,
        client_token,
        status: create ? 1 : 2,
        user_id: id
      };

      return this.userApi.waitListManage(data)
        .pipe(
          map((res: ExtendedApiResponse<WaitListResponse>): ExtendedApiResponse<WaitListResponse & {email: string}> | string => {
            if (res.status === 'error') {
              return res.msg;
            }
            return {...res, email: data.username};
          }),
          catchError((err: HttpErrorResponse) => of(err.error.msg)),
        );
    }

    return of('Error while POST to /api/join_waitlist');
  }
}
